import { isAuthorizedGQLFields } from './isAuthorized.fields.js'

export type PathPermissionsFields = 'basic' | 'all'

export function pathPermissionsGQLFields(
  // eslint-disable-next-line unused-imports/no-unused-vars
  fields: PathPermissionsFields,
): string {
  return `
    path
    isAuthorized {
      ${isAuthorizedGQLFields('basic')}
    }
  `
}
